import summary_table_pagination from "./summary_table_pagination.js";

const RowSpanRender = (value, row, index) => {
  let obj = {
    children: value,
    attrs: {
      rowSpan: 1,
    },
  };
  let pos_in_total = col_uitls.data.findIndex((d) => d.id == row.id);
  let total_remaining = col_uitls.data.length - pos_in_total;
  let remaining = summary_table_pagination.pageSize - index;
  let rowSpanCounter = 1;
  for (
    let i = pos_in_total + 1;
    i < pos_in_total + Math.min(remaining, total_remaining);
    i++
  ) {
    if (col_uitls.data[i].mv === row.mv) {
      rowSpanCounter++;
    } else {
      break;
    }
  }
  obj.attrs.rowSpan = rowSpanCounter;

  if (index !== 0 && col_uitls.data[pos_in_total - 1].mv == row.mv) {
    obj.attrs.rowSpan = 0;
  }
  return obj;
};
const col_uitls = {
  data: [],

  cols: [
    {
      title: "ID",
      align: "center",
      dataIndex: "id",
    },
    {
      title: "Vessel Name",
      aligh: "center",
      dataIndex: "mv",
      customRender: RowSpanRender,
      filters: [],
    },
    {
      title: "Charterer/Voyage",
      aligh: "center",
      width: 60,
      scopedSlots: { customRender: "charter_voyage" },
    },
    {
      title: "Laycan",
      align: "center",
      scopedSlots: { customRender: "laycan" },
    },
    {
      title: "Load Port ~ Disc. Port",
      align: "center",
      scopedSlots: { customRender: "load_disc_port" },
    },
    {
      title: "P&L",
      align: "center",
      scopedSlots: { customRender: "pl" },
    },
    {
      title: "B/L and Freight",
      align: "center",
      width: 600,
      scopedSlots: { customRender: "bl" },
    },
  ],

  sort_by_veseel: (va1, va2) => {
    let vessle_flag = va1.mv.localeCompare(va2.mv);
    let voyage_flag =
      va1.leg[0] == "V" && va2.leg[0] == "V"
        ? parseInt(va1.leg.slice(1)) - parseInt(va2.leg.slice(1))
        : 0;
    if (vessle_flag === 0) {
      return voyage_flag;
    } else {
      return vessle_flag;
    }
  },
};

export default col_uitls;
